<!-- Confirmation modal -->
<template>
  <WCModal position="center" @dismiss="dismiss(MODAL_EVENTS.DISMISS)">
    <!-- START: Header -->
    <WCModalHeader class="align-items-baseline">
      <h1 class="font-size-lg">
        <font-awesome-icon class="mr-2" :icon="headerIcon" />
        {{ header }}
      </h1>
      <button
        v-if="headerCancel"
        class="btn btn-link underline-link-from-center"
        @click="close(MODAL_EVENTS.HEADER_CANCEL)"
      >
        {{ headerCancel }}
      </button>
    </WCModalHeader>
    <!-- END: Header -->

    <!-- START: body -->
    <WCModalBody>
      <p>
        {{ content }}
        <!-- Confirmation for the particular name -->
        <b>{{ contentName }}</b>
      </p>
    </WCModalBody>
    <!-- END: body -->

    <!-- START: Footer -->
    <WCModalFooter v-if="confirm || cancel">
      <!-- START: Confirmation button -->
      <button
        v-if="confirm"
        @click="close(MODAL_EVENTS.CONFIRM)"
        class="btn btn-outline-primary confirm-delete"
      >
        {{ confirm }}
      </button>
      <!-- END: Confirmation button -->

      <!-- START: Cancel button -->
      <button
        v-if="cancel"
        @click="dismiss(MODAL_EVENTS.CANCEL)"
        :class="{
          'btn btn-outline-dark font-size-sm': !isCancelPrimary,
          'btn btn-outline-primary font-size-sm': isCancelPrimary,
        }"
      >
        {{ cancel }}
      </button>
      <!-- END: Cancel button -->
    </WCModalFooter>
    <!-- END: Footer -->
  </WCModal>
</template>

<script>
import ModalMixin from '@/modules/modals/mixins/ModalMixin';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCModalFooter from '@/modules/modals/components/WCModalFooter/WCModalFooter.vue';
import { MODAL_EVENTS } from '@/constants/EventConstants';

export default {
  mixins: [ModalMixin],
  props: {
    headerIcon: {
      type: String,
      required: false,
      default: '',
    },
    header: {
      type: String,
      required: true,
    },
    headerCancel: {
      type: String,
      required: false,
      default: '',
    },
    content: {
      type: String,
      requiured: true,
    },
    contentName: {
      type: String,
      required: false,
      default: '',
    },
    confirm: {
      type: String,
      required: false,
      default: '',
    },
    cancel: {
      type: String,
      required: false,
      default: '',
    },
    isCancelPrimary: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      MODAL_EVENTS,
    };
  },
  components: { WCModal, WCModalHeader, WCModalBody, WCModalFooter },
};
</script>
